// extracted by mini-css-extract-plugin
export default {"root":"_0O0lUOY7","iframe":"_31Mh7q5S"};